import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Box, Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Header />
      <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', py: 8 }}>
        <Container>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h1" sx={{ mb: 2, fontSize: '8rem', fontWeight: 700, color: 'primary.main' }}>
              404
            </Typography>
            <Typography variant="h4" sx={{ mb: 2 }}>
              Oops! Page not found
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              The page you're looking for doesn't exist or has been moved.
            </Typography>
            <Button variant="contained" component={Link} to="/" size="large">
              Return to Home
            </Button>
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default NotFound;
